import type { Defi, Exchange, Products, Section } from './types'

export const products_uk: Products[] = [
  {
    tTitle: 'products.buyAndSell',
    tDesc: 'products.appDescription',
    href: '/app',
  },
  {
    tTitle: 'products.metalCards',
    tDesc: 'products.metalCardsDescription',
    href: '/cards',
  },
  {
    tTitle: 'products.pay',
    tDesc: 'products.payDescription',
    href: '/pay',
  },
  {
    tTitle: 'products.earn',
    tDesc: 'products.earnDescription',
    href: '/earn',
  },
  {
    tTitle: 'products.credit',
    tDesc: 'products.creditDescription',
    href: '/credit',
  },
]

export const exchange_uk: Exchange[] = [
  {
    tTitle: 'products.exchangeIndex',
    tDesc: 'products.exchangeIndexDescription',
    href: 'https://crypto.com/exchange',
  },
  {
    tTitle: 'products.marginTrading',
    tDesc: 'products.marginTradingDescription',
    href: 'https://crypto.com/exchange/trade/BTC_USD',
  },
  {
    tTitle: 'products.derivatives',
    tDesc: 'products.derivativesDescription',
    href: 'https://crypto.com/exchange/trade/BTCUSD-PERP',
  },
]
export const defi_uk: Defi[] = [
  {
    tTitle: 'products.defiWallet',
    tDesc: 'products.defiWalletDescription',
    href: '/eea/defi-wallet',
  },
  {
    tTitle: 'products.browserExt',
    tDesc: 'products.browserExtDescription',
    href: '/eea/defi-wallet#wallet_extension',
  },
  {
    tTitle: 'products.desktopWallet',
    tDesc: 'products.desktopWalletDescription',
    href: '/eea/defi-wallet#defi_wallet_desktop',
  },
]

export const products_desktop_uk: Section[] = [
  {
    tTitle: 'products.sectionTitle_getStarted',
    items: [
      {
        tTitle: 'products.categoryTitle_buyAndSell',
        items: [
          {
            tTitle: 'products.app',
            tDesc: 'products.appDescription',
            href: '/eea/app',
          },
          {
            tTitle: 'products.nft',
            tDesc: 'products.nftDescription',
            href: 'https://crypto.com/nft',
          },
        ],
      },
      {
        tTitle: 'products.categoryTitle_spend',
        items: [
          {
            tTitle: 'products.metalCards',
            tDesc: 'products.metalCardsDescription',
            href: '/eea/cards',
          },
          {
            tTitle: 'products.pay',
            tDesc: 'products.payDescription',
            href: '/eea/pay',
          },
        ],
      },
      {
        tTitle: 'products.categoryTitle_grow',
        items: [
          {
            tTitle: 'products.earn',
            tDesc: 'products.earnDescription',
            href: '/eea/earn',
          },
          {
            tTitle: 'products.credit',
            tDesc: 'products.creditDescription',
            href: '/eea/credit',
          },
        ],
      },
    ],
  },
  {
    tTitle: 'products.sectionTitle_advancedTrading',
    items: [
      {
        tTitle: 'products.categoryTitle_exchange',
        items: [
          {
            tTitle: 'products.exchangeIndex',
            tDesc: 'products.exchangeIndexDescription',
            href: 'https://crypto.com/exchange',
          },
          {
            tTitle: 'products.marginTrading',
            tDesc: 'products.marginTradingDescription',
            href: 'https://crypto.com/exchange/trade/BTC_USD',
          },
        ],
      },
      {
        tTitle: 'products.categoryTitle_defi',
        items: [
          {
            tTitle: 'products.defiWallet',
            tDesc: 'products.defiWalletDescription',
            href: '/eea/defi-wallet',
          },
          {
            tTitle: 'products.browserExt',
            tDesc: 'products.browserExtDescription',
            href: '/eea/defi-wallet#wallet_extension',
          },
          {
            tTitle: 'products.desktopWallet',
            tDesc: 'products.desktopWalletDescription',
            href: '/eea/defi-wallet#defi_wallet_desktop',
          },
        ],
      },
      {
        tTitle: 'products.categoryTitle_ecosystem',
        items: [
          {
            tTitle: 'products.payMerchant',
            tDesc: 'products.payMerchantDescription',
            href: '/eea/pay-merchant',
          },
        ],
      },
    ],
  },
]
